<template>
    <section class="counter-section" :style="{ 'background-image': `url(${background})` }">
        <ul class="countdown d-flex justify-content-center">
            <li class="">
                <span class="time">
                    {{ days | two_digits }}
                </span>
                <span class="title">
                    Days
                </span>
            </li>
            <li class="">
                <span class="time">
                    {{ hours | two_digits }}
                </span>
                <span class="title">
                    Hours
                </span>
            </li>
            <li class="">
                <span class="time">
                    {{ minutes | two_digits }}
                </span>
                <span class="title">
                    Minutes
                </span>
            </li>
            <li class="">
                <span class="time">
                    {{ seconds | two_digits }}
                </span>
                <span class="title">
                    Seconds
                </span>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
    props: ['background', 'date'],
    mounted() {
        window.setInterval(() => {
            this.now = this.$moment()
        },1000);
    },
    data() {
        return {
            now: this.$moment()
        }
    },
    computed: {
        diffInMs() {
            return Math.trunc(this.$moment(this.date).diff(this.now) / 1000)
        },
        seconds() {
            return Math.trunc(this.diffInMs % 60);
        },
        minutes() {
            return Math.trunc(this.diffInMs / 60) % 60;
        },
        hours() {
            return Math.trunc(this.diffInMs / 60 / 60) % 24;
        },
        days() {
            return Math.trunc(this.diffInMs / 60 / 60 / 24);
        }
    }
}
</script>